import React from 'react'
import PropTypes from 'prop-types'
import * as request from 'services/request'
import TenantUserSelect from './tenant-user-select'
import { MissingTokensIcon } from 'pages/admin/users/users'
import { startsWith } from 'ramda'

class TenantUserSelectContainer extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      tenants: [],
      users: [],
      selecting: false,
      selectedTenantId: '',
      selectedUserId: ''
    }

    this.handleStartSelecting = this.handleStartSelecting.bind(this)
    this.handleTenantSelected = this.handleTenantSelected.bind(this)
    this.handleUserSelected = this.handleUserSelected.bind(this)
    this.handleTenantUserSelected = this.handleTenantUserSelected.bind(this)
  }

  componentDidMount () {
    this.getTenants()
  }

  componentDidUpdate () {
    window.$('.selectpicker').selectpicker('refresh')
  }

  async getTenants () {
    const response = await request.authorized('/tenants')
    const tenants = await response.json()

    if (tenants.length > 0) {
      // the user / tenant selector will be displayed, so we can go ahead and see if the user has access to other users
      this.getUsers()
    }

    this.setState({ tenants })
  }

  async getUsers () {
    try {
      const response = await request.authorized('/users')
      const users = await response.json()
      this.setState({ users })
    } catch (e) {
      // ignore 401 errors here, as it just means you don't have access to see other users
      // istanbul ignore next
      if (!e.message.startsWith('401')) throw e
    }
  }

  getSelectedTenant () {
    const { tenants, selectedTenantId } = this.state

    return tenants.find(t => t.id === selectedTenantId)
  }

  getSelectedUser () {
    const { users, selectedUserId } = this.state

    return users.find(u => u.id === selectedUserId)
  }

  getSelectedTenantName () {
    const tenant = this.getSelectedTenant()

    return tenant ? tenant.name : 'No partner selected'
  }

  getSelectedUserName () {
    const user = this.getSelectedUser()

    return user ? user.screenName : 'No user selected'
  }

  handleStartSelecting () {
    this.setState({ selecting: true })
  }

  handleTenantSelected ({ target }) {
    this.setState({ selectedTenantId: target.value })
  }

  handleUserSelected ({ target }) {
    this.setState({ selectedUserId: target.value })
  }

  handleTenantUserSelected () {
    const { onTenantUserSelect } = this.props

    onTenantUserSelect({
      tenant: this.getSelectedTenant(),
      user: this.getSelectedUser()
    })

    this.setState({ selecting: false })
  }

  renderTenantOptions () {
    const { tenants } = this.state

    return tenants.map(t => (
      <option key={t.id} value={t.id}>
        {t.name}
      </option>
    ))
  }

  renderUserOptions () {
    const { users } = this.state

    return users.map(user => (
      <option key={user.id} value={user.id}>
        <div className='user-select-option'>
          {user.screenName}
          <span
            className={
              startsWith('FB-', user.id) ? 'fa fa-facebook' : 'fa fa-twitter'
            }
          />
          {!user.hasTwitterTokens && <MissingTokensIcon />}
        </div>
      </option>
    ))
  }

  render () {
    const { selecting, selectedTenantId, selectedUserId } = this.state

    const props = {
      selecting,
      selectedTenantId,
      selectedUserId,

      onStartSelecting: this.handleStartSelecting,

      onTenantSelect: this.handleTenantSelected,
      selectedTenantName: this.getSelectedTenantName(),
      tenantOptions: this.renderTenantOptions(),

      onUserSelect: this.handleUserSelected,
      selectedUserName: this.getSelectedUserName(),
      userOptions: this.renderUserOptions(),

      onSave: this.handleTenantUserSelected
    }

    return this.state.tenants.length > 0 ? (
      <TenantUserSelect {...props} />
    ) : null
  }
}

TenantUserSelectContainer.propTypes = {
  onTenantUserSelect: PropTypes.func.isRequired
}

export default TenantUserSelectContainer



// WEBPACK FOOTER //
// ./src/components/header/tenant-user-select/index.js